import axios from 'axios.js';
import { showSnackbar } from './UiAction';
import { getApprovedSchoolListForRemove, getVtsSchoolList } from './ImportSchoolsActions';

export const GET_SCHOOL_LIST = 'GET_SCHOOL_LIST';
export const GET_SUMMARY_LIST = 'GET_SUMMARY_LIST';
export const GET_SCHOOL_SUMMARY_LIST = 'GET_SCHOOL_SUMMARY_LIST';
export const REMOVE_SCHOOLS = 'REMOVE_SCHOOLS';
export const GET_STUDENT_TARGET_LIST = 'GET_STUDENT_TARGET_LIST';
export const SCHOOL_ACTIVE = 'SCHOOL_ACTIVE';
export const SCHOOL_DEACTIVE = 'SCHOOL_DEACTIVE';
export const SCHOOL_UPDATE_DESCRIPTION = 'SCHOOL_UPDATE_DESCRIPTION';

export const getSchoolList = (data, id) => (dispatch) => {
  axios.get(`/schools`, { headers: { filter_type: data, filter_code: id } })
    .then(res => { dispatch({ type: GET_SCHOOL_LIST, payload: res.data.data }); })
    .catch(error => { console.error(error); });
};

export const getStudentTargerReportList = (data, id) => (dispatch) => {
  axios.get(`/report/student-target-report`, { headers: { filter_type: data, filter_code: id } })
    .then(res => { dispatch({ type: GET_STUDENT_TARGET_LIST, payload: res.data.data }); })
    .catch(error => { console.error(error); });
};

export const getSummaryList = (data, id) => (dispatch) => {
  axios.get(`/report/school_wise_summary`, { headers: { filter_type: data, filter_code: id } })
    .then(res => { dispatch({ type: GET_SUMMARY_LIST, payload: res.data.data }); })
    .catch(error => { console.error(error); });
};

export const getSchoolSummaryList = (data, id) => (dispatch) => {
  axios.get(`/schools/summary/registration`, { headers: { filter_type: data, filter_code: id } })
    .then(res => { dispatch({ type: GET_SCHOOL_SUMMARY_LIST, payload: res.data.data }); })
    .catch(error => { console.error(error); });
};

export const removeSchools = (data) => (dispatch) => {
  axios.post(`/schools/remove`, { "school_id": data }, { headers: { "content-type": "application/json" } })
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch(getApprovedSchoolListForRemove());
      dispatch({ type: REMOVE_SCHOOLS, payload: response.data });
    })
    .catch((error) => { dispatch(showSnackbar(error.message, 'top', "error")); });
};

// Deactivate school — sets is_inactive = {"is_inactive":1,"description":"reason","driver_snapshot":[...]}, is_vts_enabled = 0
export const schoolDeactivate = (id, description) => (dispatch) => {
  axios.post(`/schools/${id}/deactivate`, { description }).then((res) => {
    dispatch({ type: SCHOOL_DEACTIVE, payload: res.data });
    dispatch(getVtsSchoolList(1, 10));
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  }).catch((error) => { dispatch(showSnackbar(error.message, 'top', "error")); });
};

// Activate school — sets is_inactive = NULL, is_vts_enabled = 1, restores driver_id on vehicles
export const schoolActivate = (id) => (dispatch) => {
  axios.post(`/schools/${id}/activate`).then((res) => {
    dispatch({ type: SCHOOL_ACTIVE, payload: res.data });
    dispatch(getVtsSchoolList(1, 10));
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  }).catch((error) => { dispatch(showSnackbar(error.message, 'top', "error")); });
};

// Update description inline — keeps is_inactive = 1, updates description only
export const updateSchoolDescription = (id, description) => (dispatch) => {
  axios.post(`/schools/${id}/update-description`, { description }).then((res) => {
    dispatch({ type: SCHOOL_UPDATE_DESCRIPTION, payload: res.data });
    dispatch(getVtsSchoolList(1, 10));
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  }).catch((error) => { dispatch(showSnackbar(error.message, 'top', "error")); });
};

// NEW — prefetch impact counts before showing the deactivation dialog
// Returns a promise resolving to { vehicleCount, driverCount, studentCount }
export const getSchoolImpactCounts = (schoolId) => () =>
  axios.get(`/schools/${schoolId}/impact-counts`).then(res => res.data.data);